
function tagPickerDirective() {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/tagPicker',
        scope: {searchTags: '&', tagSelected: '&', addLabel:'@', placeholder:'@'},
        controller: 'TagPickerController',
        controllerAs: 'ctrl'
    }
}

module.cC({
    name: 'TagPickerController',
    inject: ['$q', '$scope', '$element', '$timeout', '$document', 'Page'],
    data: {
        isOpen: false,
        query: "",
        index: 0,
    },

    init: function() {
        this.queryChanged();
    },

    methods: {

        queryChanged: function(query) {
            this.index = 0;
            if (this.isOpen) {
                this.$q.when(this.$.searchTags({query: this.query}))
                    .then(this._setTags);
            }
        },

        toggleOpen: function() {
            (this.isOpen ? this.close : this.open)();
        },

        open: function() {
            this.isOpen = true;
            this.query = "";
            this.queryChanged("");
            this.$timeout(this._postOpen);
            this._attachHandlers();
        },

        close: function() {
            this.isOpen = false;
            this.$element.removeClass('above');
            this.isAbove = false;
            this.removeHandlers();
        },

        _postOpen: function() {
            this.$element.find('input')[0].focus();
        },

        _positionDropdown: function() {
            var dropdown = this.$element[0].querySelector('.dropdown');
            this.isAbove = this.isAbove || !this.Page.verticallyBoundByContent(dropdown);
            this.$element.toggleClass('above', this.isAbove);
        },

        _attachHandlers: function() {
            this.$document.bind("click", this._clickHandler);
            this.$element.bind("keydown", this._keydownHandler);
        },

        removeHandlers: function() {
            this.$document.unbind('click', this._clickHandler);
            this.$element.unbind("keydown", this._keydownHandler);
        },

        _clickHandler: function(event) {
            if (!this.isOpen) {
                this.removeHandlers();
            } else {
                if (!this.$element[0].contains(event.target)) {
                    this.$.$apply(this.close);
                }
            }
        },

        _keydownHandler: function(event) {
            var adjust;
            switch (event.which) {
                case 27:
                    event.preventDefault();
                    this.$.$apply(this.close);
                    break;

                case 38:
                case 40:
                    event.preventDefault();
                    adjust = event.which == 38 ? -1 : 1;
                    adjust *= this.isAbove ? -1 : 1;
                    this.$.$apply(this.setIndex.bind(this, this.index + adjust));
                    break;

                case 13:
                    event.preventDefault();
                    this.$.$apply(this.selectTag.bind(this, this.tags[this.index]));
                    break;
            }
        },

        setIndex: function(i) {
            this.index = Math.max(0, Math.min(this.tags.length - 1, i));
        },

        _setTags: function(tags) {
            this.tags = tags
            this.$timeout(this._positionDropdown);
        },

        selectTag: function(tag) {
            if (!tag.exists) {
                this.$.tagSelected({tag: tag});
                this.close();
            }
        },
    },
});


function tagListDirective($q, $http, ApiUrl) {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/tagList',
        scope: {
            tags: '=',
            params: '=',

            allowAdd: '=?',
            tagAdded: '&',

            tagRemoved: '&',
            allowRemove: '=?',

            doTagSearch: '&searchTags',
            addLabel:'@',
            placeholder: '@',
            label: '@',
            maxLines: '=',
            hiddenItems: '=',
        },
        controller: 'TagListController',
        controllerAs: 'ctrl',
        require: '^?urlTagLists',

        link: function(scope, element, attrs) {
            scope.canDelete = !!attrs.tagRemoved;
        }
    };
}

module.cC({
    name: 'TagListController',
    inject: ['$scope', '$q', '$element', '$timeout', '$attrs'],

    data: {
        tagHash: {},
    },

    watch: {
        '{collection}tags': '_buildTagHash',
        'maxLines': '_setMaxHeight',
    },

    init: function() {
        this.$.tags = this.$.tags || [];
        this._updateParams();
        this.$.hiddenItems = 0;
        this.listElement = this.$element.find('ul');
        this.itemHeight = this._findItemHeight();

        if (!this.$attrs.allowAdd) {
            this.$.allowAdd = !!this.$attrs.searchTags;
        }

        if (!this.$attrs.allowAdd) {
            this.$.allowAdd = !!this.$attrs.searchTags;
        }

        if (!this.$attrs.allowRemove) {
            this.$.allowRemove = !!this.$attrs.tagRemoved;
        }

    },

    methods: {
        addTag: function(tag) {
            this.$q.when(this.$.tagAdded({tag: tag}))
                .then(function(r) { return r || tag; })
                .then(_addToArray(this.$.tags))
                .then(this._updateParams);
        },

        removeTag: function(tag) {
            this.$q.when(this.$.tagRemoved({tag: tag}))
                .then(function() { return tag; })
                .then(_removeFromArray(this.$.tags))
                .then(this._updateParams);
        },

        searchTags: function(query) {
            return this.$.doTagSearch({query: query})
                .then(this._checkIfExists);
        },

        _checkIfExists: function(tags) {
            angular.forEach(tags, function(tag) {
                tag.exists = this._inHash(tag);
            }, this);
            return tags;
        },

        _inHash: function(tag) {
            return !!(this.tagHash[tag.slug] &&
                      this.tagHash[tag.slug][tag.value]);
        },

        _buildTagHash: function() {
            var i, tag;
            this.tagHash = {};
            for (i = 0; i < this.$.tags.length; i++) {
                tag = this.$.tags[i];
                this.tagHash[tag.slug] = this.tagHash[tag.slug] || {};
                this.tagHash[tag.slug][tag.value] = tag;
            }
            this.$timeout(this._countHiddenItems);
            this.$timeout(this._setMaxHeight);
        },

        _findItemHeight: function() {
            var item = angular.element('<li class="tag">fake</li>'), style, height;
            this.listElement.append(item);
            style = getComputedStyle(item[0]);
            height = item[0].offsetHeight +
                parseInt(style.marginTop) +
                parseInt(style.marginBottom);
            item.remove();
            return height;
        },

        _getMaxHeight: function(lines) {
            if (angular.isUndefined(lines)) return undefined;
            return lines > 0 ? (lines * this.itemHeight) :
                (this.listElement[0].scrollHeight + this.itemHeight);
        },

        _setMaxHeight: function() {
            var maxHeight = this._getMaxHeight(this.$.maxLines);
            if (angular.isUndefined(maxHeight)) {
                this.listElement.css('maxHeight', '');
            } else {
                this.listElement.css('maxHeight', maxHeight + "px");
            }
            this.$timeout(this._countHiddenItems);
        },

        _countHiddenItems: function() {
            var count = 0, height = this._getMaxHeight(this.$.maxLines);
            angular.forEach(this.listElement.find('li'), function(li) {
                count += (li.offsetTop >= height);
            });
            this.$.hiddenItems = count;
        },

        _updateParams: function() {
            if (this.$attrs.params) {
                if (!angular.isObject(this.$.params)) {
                    this.$.params = {};
                }
                angular.copy(buildTagParams(this.$.tags), this.$.params);
            }
        },
    },
});

function buildTagParams(tags) {
    var params = {}, i;
    for (i = 0; i < tags.length; i++) {
        params[tags[i].slug] = params[tags[i].slug] || [];
        params[tags[i].slug].push(tags[i].value || tags[i].name);
    }
    return params;
}

function _getItems(response) {
    return response.data.items;
}

function _removeFromArray(array) {
    return function(item) {
        var index = array.indexOf(item);
        if (index >= 0) { array.splice(index, 1); }
    }
}

function _addToArray(array) {
    return function(item) {
        var index = array.indexOf(item);
        if (index === -1) { array.unshift(item); }
    }
}

module.directive('tagPicker', tagPickerDirective);
module.directive('tagList', tagListDirective);
